import { useCallback, useEffect, useState } from "react";

const SMALL_BREAKPOINT = 480;
const MEDIUM_BREAKPOINT = 720;
const LARGE_BREAKPOINT = 1152;

interface Breakpoints {
  isLargeScreen: boolean;
  isMediumScreen: boolean;
  isSmallScreen: boolean;
  isXSmallScreen: boolean;
}

export const useBreakpoint = (): Breakpoints => {
  const [isXSmallScreen, setIsXSmallScreen] = useState<boolean>(
    window.innerWidth < SMALL_BREAKPOINT
  );
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    window.innerWidth < MEDIUM_BREAKPOINT
  );
  const [isMediumScreen, setIsMediumScreen] = useState<boolean>(
    window.innerWidth < LARGE_BREAKPOINT
  );
  const [isLargeScreen, setIsLargeScreen] = useState<boolean>(window.innerWidth > LARGE_BREAKPOINT);

  const handleResize = useCallback(() => {
    setIsXSmallScreen(window.innerWidth < SMALL_BREAKPOINT);
    setIsSmallScreen(window.innerWidth < MEDIUM_BREAKPOINT);
    setIsMediumScreen(window.innerWidth < LARGE_BREAKPOINT);
    setIsLargeScreen(window.innerWidth > LARGE_BREAKPOINT);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  const state = {
    isLargeScreen,
    isMediumScreen,
    isSmallScreen,
    isXSmallScreen,
  };

  return state;
};
